import type { Component } from 'vue'
import type { RouteRecordRaw } from 'vue-router'

import { DOCTYPES } from '@/constants/doctypes.ts'
import { PERMISSIONS } from '@/constants/permissions.ts'

const personsViewDoctypes = {
  [DOCTYPES.BANK]: [PERMISSIONS.READ], // bank = investor
  [DOCTYPES.CONTACT]: [PERMISSIONS.READ],
  [DOCTYPES.CUSTOMER]: [PERMISSIONS.READ],
  [DOCTYPES.EVENT]: [PERMISSIONS.READ],
  [DOCTYPES.SALES_PARTNER]: [PERMISSIONS.READ],
  [DOCTYPES.SUPPLIER]: [PERMISSIONS.READ],
  [DOCTYPES.TAG]: [PERMISSIONS.SELECT],
  [DOCTYPES.TW_ACTIVITY_DOCUMENTATION]: [PERMISSIONS.READ],
  [DOCTYPES.TW_OTHER]: [PERMISSIONS.READ],
  [DOCTYPES.TW_PARTNER]: [PERMISSIONS.READ],
  [DOCTYPES.TW_ROLE]: [PERMISSIONS.READ],
}

const routePersonsHome: RouteRecordRaw = {
  component: async (): Promise<Component> => {
    return await import('@/components/views/relations/PersonsView.vue')
  },
  meta: {
    doctypes: personsViewDoctypes,
  },
  name: 'persons-home',
  path: '',
}

const routePersonDetail: RouteRecordRaw = {
  component: async () => {
    return await import('@/components/views/relations/PersonDetailView.vue')
  },
  meta: {
    doctypes: personsViewDoctypes,
  },
  name: 'personDetail',
  path: ':id',
}

const routePersonsRoot: RouteRecordRaw = {
  children: [routePersonsHome, routePersonDetail],
  path: 'persons',
}

export { routePersonDetail, routePersonsHome, routePersonsRoot }
